import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { useAdsContext } from '../../contexts/AdsContext';
import useLoadAdSense from '../../hooks/useLoadAdSense';
const AdSense = () => {
    const { adsEnabled } = useAdsContext();
    useLoadAdSense();
    return (adsEnabled && (_jsxs(Box, { testId: 'ad-sense-test', backgroundColor: "color.background.light", children: [_jsx(Box, { id: "afscontainer1", testId: "afscontainer1" }), _jsx(Box, { id: "afscontainer2", testId: "afscontainer2" }), _jsx(Box, { id: "afscontainer3", testId: "afscontainer3" }), _jsx(Box, { id: "afscontainer4", testId: "afscontainer4" }), _jsx(Box, { id: "afscontainer5", testId: "afscontainer5" })] })));
};
export default AdSense;
